import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, null, -1)
const _hoisted_3 = { class: "flex-grow" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-3xl mb-6" }, "Importar Mii", -1)
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = { class: "file-path border border-black w-100 h-8 w-full px-3 flex items-center rounded-md" }
const _hoisted_7 = { class: "text-gray-400" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_10 = { class: "flex justify-end space-x-3" }
const _hoisted_11 = { class: "pt-3" }
const _hoisted_12 = { class: "pt-3" }
const _hoisted_13 = { class: "pt-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "text-3xl my-6" }, "Historial", -1)
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_text_select = _resolveComponent("ui-text-select")
  const _component_ui_table = _resolveComponent("ui-table")
  const _component_mii_statuses = _resolveComponent("mii-statuses")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_ui_button, {
          label: "Seleccionar",
          onClick: _ctx.pickFile,
          disabled: _ctx.isLoading
        }, null, 8, ["onClick", "disabled"]),
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, [
            (_ctx.file)
              ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.file.name), 1))
              : (_openBlock(), _createBlock("span", _hoisted_9, "No hay archivo seleccionado"))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_ui_text_select, {
            label: "Mes",
            items: _ctx.months,
            onSelected: _cache[1] || (_cache[1] = (evt) => (_ctx.month = evt))
          }, null, 8, ["items"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_ui_text_select, {
            label: "Año",
            items: _ctx.years,
            onSelected: _cache[2] || (_cache[2] = (evt) => (_ctx.year = evt))
          }, null, 8, ["items"])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_ui_text_select, {
            label: "Modo",
            items: _ctx.modes,
            onSelected: _cache[3] || (_cache[3] = (evt) => (_ctx.mode = evt))
          }, null, 8, ["items"])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_ui_button, {
            label: "Subir Archivo",
            onClick: _ctx.uploadFile,
            disabled: !_ctx.file || !_ctx.month || !_ctx.year || !_ctx.mode,
            loading: _ctx.isLoading
          }, null, 8, ["onClick", "disabled", "loading"])
        ])
      ]),
      _createVNode("input", {
        id: "fileinput",
        type: "file",
        ref: "fileRef",
        style: {"display":"none"},
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.charge && _ctx.charge(...args))),
        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFilePicked && _ctx.onFilePicked(...args))),
        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      }, null, 544),
      _hoisted_14,
      _createVNode(_component_ui_table, {
        clickable: true,
        headers: _ctx.headers,
        actions: _ctx.actions,
        items: _ctx.items
      }, null, 8, ["headers", "actions", "items"]),
      _createVNode("div", _hoisted_15, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_mii_statuses, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_16
  ]))
}